import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest, HttpParams } from '@angular/common/http';
import { Observable, BehaviorSubject, EMPTY } from 'rxjs';
import { map, publishReplay, refCount } from 'rxjs/operators';

import * as d3 from 'd3';

/*import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
*/
import {mContentUsage, School, Year, Grade, Class, Subject, SchoolCategory, Country, Region, User, Role} from '../model/userUsage.model';

import { environment } from '../../environments/environment';
import { stringify } from '@angular/compiler/src/util';
import { Subscription } from 'rxjs';

@Injectable()
export class learningContentDataService {

  headers: any;
  options: any;
  private date$Filter = new BehaviorSubject<any>({
    startDate: '',
    endDate: ''
  });
  currentDateFilter = this.date$Filter.asObservable();

  private other$Filter = new BehaviorSubject<any>({});
  currentOtherFilters = this.other$Filter.asObservable();

  // device usage data
  private rawContentUsage$Data = new BehaviorSubject<mContentUsage[]>([]);
  readonly contentUsage$Data = this.rawContentUsage$Data.asObservable();

  // overview tab section 3 Application Overview
  private rawContentOverview$Data = new BehaviorSubject<any[]>([]);
  readonly contentOverview$Data = this.rawContentOverview$Data.asObservable();

  // overview tab section 3 Application Overview
  private rawContentOverviewTab$Data = new BehaviorSubject<any[]>([]);
  readonly contentOverviewTab$Data = this.rawContentOverviewTab$Data.asObservable();

  // overview tab section 3 Application Overview
  private rawContentDailyTrend$Data = new BehaviorSubject<any[]>([]);
  readonly contentDailyTrend$Data = this.rawContentDailyTrend$Data.asObservable();

  // overview tab section 3 Application Overview
  private rawNewContentOverview$Data = new BehaviorSubject<any[]>([]);
  readonly newContentOverview$Data = this.rawNewContentOverview$Data.asObservable();

  // overview tab section 3 Application Overview
  private rawNewContentOverviewTab$Data = new BehaviorSubject<any[]>([]);
  readonly newContentOverviewTab$Data = this.rawNewContentOverviewTab$Data.asObservable();
  private dateFilter:Subscription;
  constructor( private http: HttpClient) {
    const headersItem = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    this.headers = headersItem;
  }

  setDateFilter(start, end?) {

    if (start) {
      if (start && end) {
        this.date$Filter.next(Object.assign({}, {
          startDate: start + 'T00:00:00Z',
          endDate: end + 'T00:00:00Z'
        }));
      } else {
        let startDate: string;
        let endDate: string;
        const curDate = new Date();
        endDate = curDate.getFullYear() + '-' + ('0' + (curDate.getMonth() + 1)).slice(-2) + '-' + ('0' + curDate.getDate()).slice(-2) + 'T00:00:00Z';

        let diffInHours = 0;
        if (start === '24Hours') {
          diffInHours = 24 * 3600;
        } else if (start === '7Days') {
          diffInHours = 7 * (24 * 3600);
        } else if (start === '30Days') {
          diffInHours = 30 * (24 * 3600);
        } else if (start === '90Days') {
          diffInHours = 90 * (24 * 3600);
        } else if (start === 'Year') {
          diffInHours = 365 * (24 * 3600);
        }

        const tmpDate = new Date(curDate.getTime() - (diffInHours * 1000));
        startDate = tmpDate.getFullYear() + '-' + ('0' + (tmpDate.getMonth() + 1)).slice(-2) + '-' + ('0' + tmpDate.getDate()).slice(-2) + 'T00:00:00Z';

        this.date$Filter.next(Object.assign({}, {
          startDate, endDate
        }));

      }
    }
  }

  setOtherFilter(filter: any) {
    if (filter) {
      this.other$Filter.next(Object.assign({}, filter));
    } else {
      this.other$Filter.next(Object.assign({}, EMPTY));
    }
  }


  // Get ApplicationUsageData from server | HTTP GET
  loadContentUsageData() {
    let count = 0;
    // toto: add all data filter
    if(this.dateFilter){
      this.dateFilter.unsubscribe();
    }
    this.dateFilter = this.currentDateFilter.subscribe( data => {
      const startDate = data.startDate;
      const endDate = data.endDate;
      count=count+1;
      let URLSearchParams = new HttpParams();

      URLSearchParams = URLSearchParams.set('startDate', startDate);
      URLSearchParams = URLSearchParams.set('endDate', endDate);

      this.options = { headers: this.headers, params: URLSearchParams };
      //if(count==1){
      this.http.get(environment.dashAPI + '/content', this.options).subscribe(data => {
        try {
          this.rawContentUsage$Data.next(Object.assign([], data));
        } catch (err) {
          this.rawContentUsage$Data.next(Object.assign([], EMPTY));
          this.clearUserCache();
        }
      }, error => {
        this.rawContentUsage$Data.next(Object.assign([], EMPTY));
        this.clearUserCache();
      });
    //}
    });
  }

  // Clear configs
  clearUserCache() {
    this.rawContentUsage$Data.next(Object.assign([], EMPTY));
    this.rawContentOverview$Data.next(Object.assign([], EMPTY));
    this.rawContentOverviewTab$Data.next(Object.assign([], EMPTY));
    this.rawContentDailyTrend$Data.next(Object.assign([], EMPTY));
    this.rawNewContentOverview$Data.next(Object.assign([], EMPTY));
    this.rawNewContentOverviewTab$Data.next(Object.assign([], EMPTY));
  }

  // overview tab and devices tab
  getContentOverviewData() {
    /* let filter = {};
    this.currentOtherFilters.subscribe( data => {
      //
      filter = data;
    }); */

    this.contentUsage$Data.subscribe( data => {
      if (data && data.length > 0) {
        let filterredData: any[] = data;

        this.currentOtherFilters.subscribe( filter => {
          if (filter) {
            filterredData = data.filter(function(item){
              for (var key in filter) {
                if (item[key] === undefined || item[key] != filter[key]) {
                  return false;
                }
              }
              return true;
            });
          }

          if (filterredData && filterredData.length > 0) {

            const tmpData1 = d3.nest<mContentUsage, number>()
              .key(function(d: any) { return d.content_media_type; })
              .rollup(function(v) {
                return d3.sum(v, function(g: any) { return parseInt(g.no_of_contents); });
              })
              .sortKeys(d3.ascending)
              .entries(filterredData);

            const tmpData2 = d3.nest<mContentUsage, number>()
              .key(function(d: any) { return d.content_media_type; })
              .rollup(function(v) {
                return d3.sum(v, function(g: any) { return parseInt(g.no_of_users_viewed); });
              })
              .sortKeys(d3.ascending)
              .entries(filterredData);

            const tmpData3 = d3.nest<mContentUsage, number>()
              .key(function(d: any) { return d.content_media_type; })
              .rollup(function(v) {
                return d3.sum(v, function(g: any) { return parseInt(g.no_of_users_launched); });
              })
              .sortKeys(d3.ascending)
              .entries(filterredData);

            const tmpData4 = d3.nest<mContentUsage, number>()
              .key(function(d: any) { return d.content_media_type; })
              .rollup(function(v) {
                return d3.sum(v, function(g: any) { return parseInt(g.no_of_users_completed); });
              })
              .sortKeys(d3.ascending)
              .entries(filterredData);

            //console.log("tmpData >>> " + JSON.stringify(tmpData1));
            var i;
            var tmpData = [];
            for (i = 0; i < tmpData1.length; i++){
              tmpData[i] = {};
              tmpData[i].id = tmpData1[i]['key'];
              if (tmpData1[i]['value']>=0) {
                  tmpData[i].content_count = tmpData1[i]['value'];
              }

              if (tmpData2[i]['value']>=0) {
                  tmpData[i].user_count = tmpData2[i]['value'];
              }

              if (tmpData3[i]['value']>=0) {
                  tmpData[i].launch_count = tmpData3[i]['value'];
              }

              if (tmpData4[i]['value']>=0) {
                  tmpData[i].complete_count = tmpData4[i]['value'];
              }

            }

            tmpData.sort(function(a, b){return b.content_count - a.content_count});
            //console.log("tmpData >>> " + JSON.stringify(tmpData));

            let j = 0;
            var tmp = [];
            for (j = 0; j < tmpData.length; j++){
                tmp[j] = {};
                tmp[j].id = tmpData[j].id;
                tmp[j].count = tmpData[j].content_count;
            }

            //console.log("tmpData >>> " + JSON.stringify(tmp));

            this.rawContentOverview$Data.next(Object.assign([], tmp));
            this.rawContentOverviewTab$Data.next(Object.assign([], tmpData));
          } else {
            this.rawContentOverview$Data.next(Object.assign([], EMPTY));
            this.rawContentOverviewTab$Data.next(Object.assign([], EMPTY));
          }
        });
      } else {
        this.rawContentOverview$Data.next(Object.assign([], EMPTY));
        this.rawContentOverviewTab$Data.next(Object.assign([], EMPTY));
      }
    });
  }

  // overview tab and devices tab
  getContentDailyTrendData() {
    /* let filter = {};
    this.currentOtherFilters.subscribe( data => {
      //
      filter = data;
    }); */
    this.contentUsage$Data.subscribe( data => {
      if (data && data.length > 0) {

        let filterredData: any[] = data;

        this.currentOtherFilters.subscribe( filter => {

          if (filter) {
            filterredData = data.filter(function(item){
              for (var key in filter) {
                if (item[key] === undefined || item[key] != filter[key]) {
                  return false;
                }
              }
              return true;
            });
          }

          if (filterredData && filterredData.length > 0) {
            const tmpData = d3.nest<mContentUsage, number>()
              .key(function(d: any) { return d.content_media_type; })
              .key(function(d: any) { return d.activity_date; })
              .rollup(function(v) {
                return d3.sum(v, function(g: any) { return parseInt(g.no_of_users_viewed); });
              })
              .sortKeys(d3.ascending)
              .entries(filterredData);
            // console.log("trend data >>> " + JSON.stringify(tmpData));
            let i;
            let result: any[] = [];
            for (i = 0; i < tmpData.length; i++){
                result[i] = {};
                result[i].id = tmpData[i]['key'];
                //tmpData[i].count = tmpData[i]['value'];
                //delete tmpData[i].key;
                //delete tmpData[i].value;
                if (tmpData[i].values) {
                  let j = 0;
                  result[i]['values'] = [];
                  for (j = 0; j < tmpData[i].values.length; j ++) {
                    var from = tmpData[i].values[j].key.split('-');
                    //var f = new Date(from[2], from[1] - 1, from[0])
                    var mydate = new Date(from[2], from[1] - 1, from[0], 0, 0, 0, 0);
                    result[i]['values'].push({
                      'date': mydate,
                      'count': tmpData[i].values[j].value
                    });
                    result[i].values.sort((a, b) => a.date.getTime() - b.date.getTime());
                  }
                  //delete tmpData[i].values;
                }
            }
            // console.log("Per trend data >>> " + JSON.stringify(result));
            this.rawContentDailyTrend$Data.next(Object.assign([], result));
          } else {
            this.rawContentDailyTrend$Data.next(Object.assign([], EMPTY));
          }
        });

      } else {
        this.rawContentDailyTrend$Data.next(Object.assign([], EMPTY));
      }
    });
  }

  // device tab
  getNewContentUploadData() {
    /* let filter = {};
    this.currentOtherFilters.subscribe( data => {
      //
      filter = data;
    }); */

    this.contentUsage$Data.subscribe( data => {
      if (data && data.length > 0) {
        let filterredData: any[] = data;

        this.currentOtherFilters.subscribe( filter => {
          if (filter) {
            filterredData = data.filter(function(item){
              for (var key in filter) {
                if (item[key] === undefined || item[key] != filter[key]) {
                  return false;
                }
              }
              return true;
            });
          }

          if (filterredData && filterredData.length > 0) {

            const tmpData1 = d3.nest<mContentUsage, number>()
              .key(function(d: any) { return d.content_media_type; })
              .rollup(function(v) {
                return d3.sum(v, function(g: any) { return parseInt(g.no_of_new_contents_added); });
              })
              .sortKeys(d3.ascending)
              .entries(filterredData);

            const tmpData2 = d3.nest<mContentUsage, number>()
              .key(function(d: any) { return d.content_media_type; })
              .rollup(function(v) {
                return d3.sum(v, function(g: any) { return parseInt(g.no_of_upload_from_teachers); });
              })
              .sortKeys(d3.ascending)
              .entries(filterredData);

            const tmpData3 = d3.nest<mContentUsage, number>()
              .key(function(d: any) { return d.content_media_type; })
              .rollup(function(v) {
                return d3.sum(v, function(g: any) { return parseInt(g.no_of_upload_from_cp); });
              })
              .sortKeys(d3.ascending)
              .entries(filterredData);

            console.log("tmpData >>> " + JSON.stringify(tmpData1));
            var i;
            var tmpData = [];
            for (i = 0; i < tmpData1.length; i++){
              tmpData[i] = {};
              tmpData[i].id = tmpData1[i]['key'];
              if (tmpData1[i]['value']>=0) {
                  tmpData[i].content_count = tmpData1[i]['value'];
                }

              if (tmpData2[i]['value']>=0) {
                  tmpData[i].teacher_count = tmpData2[i]['value'];
                }

              if (tmpData3[i]['value']>=0) {
                  tmpData[i].curriculum_count = tmpData3[i]['value'];
                }
            }

            tmpData.sort(function(a, b){return b.content_count - a.content_count});
           // console.log("tmpData after >>> " + JSON.stringify(tmpData));

            let j = 0;
            var tmp = [];
            for (j = 0; j < tmpData.length; j++){
                tmp[j] = {};
                tmp[j].id = tmpData[j].id;
                tmp[j].count = tmpData[j].content_count;
            }

            //console.log("tmpData >>> " + JSON.stringify(tmp));

            this.rawNewContentOverview$Data.next(Object.assign([], tmp));
            this.rawNewContentOverviewTab$Data.next(Object.assign([], tmpData));
          } else {
            this.rawNewContentOverview$Data.next(Object.assign([], EMPTY));
            this.rawNewContentOverviewTab$Data.next(Object.assign([], EMPTY));
          }
        });
      } else {
        this.rawNewContentOverview$Data.next(Object.assign([], EMPTY));
        this.rawNewContentOverviewTab$Data.next(Object.assign([], EMPTY));
      }
    });
  }

  //end
}
